/*
 * Copyright © 2015-2019 Serenova, LLC. All rights reserved.
 */

/**
 *
 * EcgForm
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { DetailHeader, InputField, ToggleField } from 'cx-ui-components';
import styled from 'styled-components';
import DetailWrapper from '../../../../components/DetailWrapper';
import { Fragment } from 'react';
import { injectIntl } from 'react-intl';

const WrappedDetailHeader = styled(DetailHeader)`
  margin-left: 35px;
`;

const GlobalDialSettingsContainer = styled.div`
  display: flex;
`;

const Label = styled.label`
  display: inline-block;
  font-size: 13px;
  margin-top: 10px;
`;

function EcgForm({
  isSaving,
  inherited,
  userHasUpdatePermission,
  isWebRtcEnabled,
  sidePanelUpdatePermissions,
  intl: { formatMessage },
}) {
  return (
    <Fragment>
      <DetailWrapper open data-automation="ecgPropertiesSVG">
        <WrappedDetailHeader text="Properties" />
        <InputField
          name="properties.trunkId"
          label="Trunk ID *"
          componentType="input"
          inputType="text"
          data-automation="integrationsTrunkId"
          disabled={isSaving || inherited || !userHasUpdatePermission}
        />
        <ToggleField
          name="properties.webRtc"
          label="WebRTC"
          data-automation="integrationsWebRtc"
          disabled={isSaving || inherited || !userHasUpdatePermission}
        />
        {isWebRtcEnabled && (
          <DetailWrapper childWrapper open data-automation="webRtcExtensionLabelSVG">
            <WrappedDetailHeader 
              text={formatMessage({
                id: 'integrations.ecg.webrtcExtensionLabel',
                defaultMessage: 'WebRTC Extension Label'
              })} 
            />
            <InputField
              name="ecgWebRtcLabel"
              label="Label *"
              componentType="input"
              inputType="text"
              data-automation="ecgWebRtcExtensionLabel"
              disabled={isSaving || inherited || !userHasUpdatePermission}
            />
          </DetailWrapper>
        )}
        {/* HIDDEN as part of CXV1-31311
          <DetailWrapper childWrapper open data-automation="globalDialSettingsSVG">
          <WrappedDetailHeader text="Global Dial Settings" />
          <GlobalDialSettingsContainer>
            <InputField
              name="properties.extensionPrefix"
              label="Extension Prefix"
              labelWidth="auto"
              componentType="input"
              inputType="text"
              data-automation="integrationsExtensionPrefix"
              disabled={
                isSaving || inherited || !userHasUpdatePermission || !sidePanelUpdatePermissions.ecgGlobalDialParams
              }
            />
            <Label>example: 12345#+15551234567</Label>
          </GlobalDialSettingsContainer>
        </DetailWrapper> */}
      </DetailWrapper>
    </Fragment>
  );
}

EcgForm.propTypes = {
  isSaving: PropTypes.bool,
  inherited: PropTypes.bool,
  userHasUpdatePermission: PropTypes.bool,
  sidePanelUpdatePermissions: PropTypes.object,
  isWebRtcEnabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  intl: PropTypes.object.isRequired,
};

export default injectIntl(EcgForm);
